// extracted by mini-css-extract-plugin
export default {"addEbook":"AddEbook_addEbook__nMz4e","info":"AddEbook_info__UPQlw"};